import { Link } from "react-router-dom";
import "./FailedUnsubscrbe.css";

const FailedUnsubscrbe = () => {
  return (
    <section className="failed-unsubscribe-page">
      <div className="failed-unsubscribe-content">
        <div className="failed-unsubscribe-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" role="img">
            <path d="M4 6.5h16v11H4z" />
            <path d="m4.5 7 7.5 6 7.5-6M6 4l12 16" />
          </svg>
        </div>

        <p className="failed-unsubscribe-eyebrow">EvoNext RegPulse</p>

        <h1>We couldn't process the request.</h1>

        <p className="failed-unsubscribe-message">
          You may already be unsubscribed, or we ran into a temporary issue on
          our end.
        </p>

        <Link to="/home" className="failed-unsubscribe-home-link">
          www.evonext.ai <span aria-hidden="true">→</span>
        </Link>
      </div>
    </section>
  );
};

export default FailedUnsubscrbe;
